<template>
	<Loader class="section" :state="promise">
		<div class="newsletter container row  ">
			<FormLayout max-width="500px" :action="submit" :isValid="validator.passes" class="newsletter__form">
				<template #default>
					<div>
						<TextField alignment="center" class="newsletter__form-title">
							<div v-html="content.description"></div>
						</TextField>

						<div class="newsletter__form-wrapper">
							<InputComponent
								class="text-micro newsletter-submit"
								v-if="isFieldVisible('email')"
								v-model="data.email"
								:label="labels.email"
								required
								floating-label
								:is-valid="!submitted || validator.fields.email.valid"
								validation-message="Du må fylle ut e-postadresse. "
							>
								<template #right>
									<ButtonComponent
										theme="primary"
										label="Meld deg på"
										success-label="Fullført"
										:state-timeout="4000"
										type="submit"
										:promise="promise"
									/>
								</template>
							</InputComponent>
						</div>
					</div>
				</template>
				<template #onError>
					<TextField alignment="center">
						<h1 class="newsletter__form-title--error">Noe gikk galt..</h1>
					</TextField>
					<div class="newsletter__form-wrapper--error">
						<ButtonComponent theme="primary" label="Tilbake til forsiden" tag="router-link" to="/" />
					</div>
				</template>
				<template #onSuccess>
					<TextField alignment="center" class="newsletter__form-title--success"> </TextField>
					<div class="newsletter__form-wrapper--success">
						<ButtonComponent theme="primary" label="Tilbake til forsiden" tag="router-link" to="/" />
					</div>
				</template>
			</FormLayout>

			<div v-if="!responsive" :style="cssVars" class="newsletter__background-image"></div>
		</div>
	</Loader>
</template>

<script>
import Validator from '@/mixins/validator'
import PageWidth from '@/mixins/pagewidth'
import { Clone } from '@/utils'
import TextField from '@/components/TextField'
import FormLayout from '@/components/FormLayout'
import Slider from '@/components/Slider'
import Layout from '@/layouts/Default'
import Icon from '@/components/Icon'
import BackgroundImage from '@/components/Gallery/Component'

const template = {
	email: null,
}

export default {
	mixins: [Validator, PageWidth],
	props: {
		fields: {
			type: Array,
			default: () => [],
		},
		content: {
			type: Object,
			default: () => ({}),
		},
	},

	data() {
		return {
			data: Clone(template),

			promise: null,
			submitted: false,
			validator: {
				rules: {
					email: 'required|email',
				},
				labels: 'labels',
				data: 'data',
			},
		}
	},
	computed: {
		labels() {
			return {
				email: 'E-post',
			}
		},
		cssVars() {
			return {
				'--background-image': `url(${this.content.backgroundImage.url})`,
			}
		},
	},
	methods: {
		submit() {
			this.submitted = true

			if (!this.validator.passes) return
			return fetch('/api/newsletter', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ email: this.data.email }),
			}).then(() => {
				this.reset()
			})
		},
		reset() {
			this.data = Clone(template)
		},

		isFieldVisible(key) {
			let inclusions = this.fields.filter(f => !f.startsWith('!'))
			let exclusions = this.fields.filter(f => f.startsWith('!')).map(f => f.substring(1))
			if (inclusions.length) return inclusions.includes(key)
			if (exclusions.length) return !exclusions.includes(key)
			return true
		},
	},
	created() {},

	components: {
		TextField,
		FormLayout,
		Slider,
		Layout,
		Icon,
		BackgroundImage,
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_color.scss';
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.newsletter {
	&__background-image {
		background: $dark var(--background-image) no-repeat right center;
		height: 500px;
		width: 100%;
	}
	&__form {
		position: absolute;
		max-width: 500px;
		z-index: 1;
		align-self: center;
		margin-top: 5rem;
		text-align: center;

		@include respond-below('phone') {
			.form__content {
				padding: 1.3rem;
			}
			position: initial;
			margin: 0;
		}

		h2 {
			margin: 0;
		}
		p {
			margin-top: 5px;
		}

		&-title {
			&--success {
				padding: 0 2rem 1rem 2rem;
			}
			&--error {
				@extend .newsletter__form-title--success;
				color: $error;
			}
		}
		&-wrapper {
			@include respond-below('phone') {
				padding: 0rem;
			}
			&--success {
				padding: 0.5rem 2.5rem 1.5rem 2.5rem;
				@include respond-below('phone') {
					padding: 0rem;
				}
			}
			&--error {
				@extend .newsletter__form-wrapper--success;
			}
		}
	}
}

.newsletter-submit {
	.elder-input__field {
		max-height: 45px;
	}
	.elder-input__wrapper {
		flex-wrap: wrap;
		margin: -0.5rem;
		margin-bottom: -1.4rem;
		align-items: center;

		& > * {
			margin: 0.5rem !important;
		}

		& > .elder-button {
			flex-grow: 1;
		}
	}
}
</style>
